module.exports = __webpack_public_path__ + "static/img/img3.20561cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qmyd/qgz/img3.png
// module id = hUJI
// module chunks = 36